import React from "react";

const Screenloader = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="pt-[40px] flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-text-secondary">Loading...</p>
        </div>
      </div>
    </div>
  );
};

export default Screenloader;
